
import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  mounted () {},
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Sales')
    },
    Tabs () {
      return [
        { Name: this.Translate('Sales'), Link: 'Orders', Access: this.Access('Sales_Orders_Read') },
        { Name: this.Translate('Customers'), Link: 'Customers', Access: this.Access('CRM_Customers_Read') }
      ] as Array<CookiesTabs>
    }
  },
  methods: {},
  watch: {}
})
